import { StandardLonghandProperties as CSS } from 'csstype';

export type Theme = {
	background: {
		primary: CSS['backgroundColor'];
		primaryAlpha: CSS['backgroundColor'];
		secondary: CSS['backgroundColor'];
		danger: CSS['backgroundColor'];
		disabled: CSS['backgroundColor'];
	};
	color: {
		primary: CSS['color'];
		disabled: CSS['backgroundColor'];
	};
	padding: {
		edge: string;
	};
};

export const LightTheme: Theme = {
	background: {
		primary: '#004294',
		primaryAlpha: 'rgba(0, 66, 148, 0.5)',
		secondary: '#f5f5f5',
		danger: '#ff0000',
		disabled: '#777',
	},
	color: {
		primary: '#004294',
		disabled: '#777',
	},
	padding: {
		edge: '1rem',
	},
};
